import { Component, Input, Output, EventEmitter } from '@angular/core';
export class AmdOverlayComponent {
    constructor() {
        this.isActive = false;
        this.isFixed = false;
        this.onOverlayClicked = new EventEmitter();
    }
    /**
     * @return {?}
     */
    onClick() {
        this.onOverlayClicked.emit();
    }
}
AmdOverlayComponent.decorators = [
    { type: Component, args: [{
                selector: 'amd-overlay',
                template: "<div class=\"amd-overlay\" [class.amd-overlay--fixed]=\"isFixed\" (click)=\"onClick()\" [class.amd-overlay--visible]=\"isActive\"> </div>"
            },] },
];
/**
 * @nocollapse
 */
AmdOverlayComponent.ctorParameters = () => [];
AmdOverlayComponent.propDecorators = {
    'isActive': [{ type: Input },],
    'isFixed': [{ type: Input },],
    'onOverlayClicked': [{ type: Output },],
};
function AmdOverlayComponent_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdOverlayComponent.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdOverlayComponent.ctorParameters;
    /** @type {?} */
    AmdOverlayComponent.propDecorators;
    /** @type {?} */
    AmdOverlayComponent.prototype.isActive;
    /** @type {?} */
    AmdOverlayComponent.prototype.isFixed;
    /** @type {?} */
    AmdOverlayComponent.prototype.onOverlayClicked;
}
//# sourceMappingURL=overlay.component.js.map
//# sourceMappingURL=overlay.component.js.map
